import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://excffmpypcwzmtvzuyaz.supabase.co'; // Replace with your Supabase URL
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV4Y2ZmbXB5cGN3em10dnp1eWF6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk3ODIzNzQsImV4cCI6MjA1NTM1ODM3NH0.sIER3mWu1ii8ItRUfT6IPn9NT8XxNlmging1OElRQEw'; // Replace with your Supabase Anon Key

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
